<div class="container">
	<div class="overlay-bg"></div>
	<div class="mid-content">
		@if (form) {
			<div
				class="p-relative form-container"
				style="
					margin-right: 1px;
					border-top-left-radius: 25px;
					border-bottom-left-radius: 25px;
					background-color: white;
				">
				<div @fadeAndSlideUp>
					<form novalidate [formGroup]="form" (ngSubmit)="login()">
						<div class="nice-border">
							<div class="ui-g login-block p-1">
								<div class="ui-g-12 ui-lg-12 p-0">
									<div class="text-center">
										<img src="./assets/img/smartyCubes-logo.png" alt="SmartyCube" />
									</div>
								</div>
								<div
									class="ui-lg-12 ui-md-12 ui-g-12"
									style="
										display: block;
										padding: 0.5rem;
										padding-top: 20px;
										border-top: 1px solid rgba(204, 204, 204, 0.48);
									">
									<label>
										<b>{{ 'login.userCode' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.userCode' | translate }}"
										type="text"
										pInputText
										name="email"
										class="w-100"
										formControlName="email" />
									<sis-validation-summary [form]="form" name="email"></sis-validation-summary>
								</div>
								<div class="ui-lg-12 ui-md-12 ui-g-12 pb-2">
									<label>
										<b>{{ 'login.password' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.password' | translate }}"
										type="password"
										class="w-100"
										pPassword
										[feedback]="false"
										name="password"
										formControlName="password" />
									<sis-validation-summary [form]="form" name="password"></sis-validation-summary>
								</div>
								@if (customeLoginData.dealerName) {
									<div class="ui-lg-12 ui-md-12 ui-g-12">
										<label>
											<b>{{ 'loginDealer' | translate }}</b>
										</label>
										<div class="ui-inputgroup">
											<input
												[disabled]="true"
												class="w-100"
												pInputText
												[value]="customeLoginData.dealerName"
												style="opacity: 0.8" />
											<button
												pButton
												type="button"
												icon="fas fa-trash"
												class="ui-button-danger"
												(click)="clearLoginData()"></button>
										</div>
									</div>
								}
								<!--<div class="ui-lg-12 ui-md-12 ui-g-12" *ngIf="!isDemoMode">
                            <small class="forgotPassword" style="font-size: 13.333px">
                              <a href="#/login/forgot-password">{{ 'login.login-forgot-password' | translate }}</a>
                            </small>
                          </div>-->
								<ng-template #loginedTem>
									<div class="ui-g">
										<div class="ui-g-12 ui-lg-12 ui-md-12 text-center">
											<h2>{{ 'logined' | translate }}</h2>
										</div>
									</div>
								</ng-template>
								@if (isLoginedByToken === false) {
									<p-footer class="ui-lg-12 login-border text-right">
										<button
											type="submit"
											[disabled]="isLoginValid"
											class="btn-login action-btn btn-color ui-dark-button w-100 p-0-5">
											<span>
												{{ 'login.sign-in' | translate }}
												<span style="float: right; padding-right: 10px"><i class="fas fa-sign-in-alt"></i></span>
											</span>
										</button>
									</p-footer>
								}
							</div>
						</div>
					</form>
				</div>
			</div>
		}
		<div class="p-relative img-container">
			<div style="height: 100%" @fadeAndSlideUp>
				<div class="card-right" style="margin-left: -1px">
					<img src="./assets/img/smartyCube-login-image.png" />
				</div>
			</div>
		</div>
	</div>
</div>

<p-dialog
	[header]="'2FA' | translate"
	[(visible)]="isDialogVisible"
	[style]="{ width: '500px' }"
	[modal]="true"
	[contentStyle]="{ 'min-height': '25vh' }"
	(onHide)="resetAll()">
	<div class="ui-g" [formGroup]="loginForm">
		<div class="ui-lg-1 ui-md-1 ui-g-12 read-only"></div>
		<div class="ui-lg-10 ui-md-10 ui-g-12 read-only">
			<div class="iconLock">
				<span><i class="fa fa-unlock-alt"></i></span>
			</div>
			<span class="loginParameter">{{ loginParametersInfo?.user2FAContactInfo }} {{ '2faLabel' | translate }}</span>
		</div>
		<div class="ui-lg-1 ui-md-1 ui-g-12 read-only text-right"></div>
		<div class="ui-lg-2 ui-md-2 ui-g-12 read-only"></div>

		<div class="ui-lg-8 ui-md-8 ui-g-12 text-right">
			<fieldset>
				<input
					type="text"
					name="password"
					id="password-input"
					formControlName="code"
					inputmode="numeric"
					(keyup.enter)="control()"
					autofocus
					minlength="5"
					maxlength="5"
					size="5"
					value="" />
			</fieldset>
		</div>
		<div class="ui-lg-2 ui-md-2 ui-g-12 read-only"></div>
	</div>
	<p-footer class="pt-0">
		<div class="ui-g">
			<div class="ui-g-4 ui-md-4 ui-g-12 text-center">
				@if (!isRetryTimerEnds) {
					<div>
						<span class="iconTimer"><i class="fa fa-clock"></i></span>
						<span class="iconTimerText">
							{{ timer }}
							<span class="sn">sn.</span>
						</span>
					</div>
				}
				@if (isRetryTimerEnds) {
					<button
						type="button"
						pButton
						label="{{ 'retryToConnect' | translate }}"
						(click)="retryToConnect()"
						class="ui-dark-button w-100"></button>
				}
			</div>
			<div class="ui-g-8 ui-md-8 ui-g-12 text-right pr-0">
				<button
					type="button"
					pButton
					label="{{ 'control' | translate }}"
					(click)="control()"
					[disabled]="loginForm.invalid"
					class="ui-green-button"></button>
			</div>
		</div>
	</p-footer>
</p-dialog>
